import React from "react";
import CreateButton from "../CreateButton";
import { CiImport } from "react-icons/ci";
import { PiExportLight } from "react-icons/pi";

export default function TableSearchButton(props) {
    return (

        <div className="table-search-buttons-wrap">
            <div className="table-search-button-group">
                <div className="table-search-button-item"><CreateButton createButtonTitle="Create Question with Assessment" to="create-question-add-to-assessment" variant="small-filled" /></div>
                <div className="table-search-button-item"><CreateButton createButtonTitle="Create Question" to="new-question" variant="small-filled" /></div>
                <div className="table-search-button-item"><CreateButton
                    createButtonTitle="Import Questions"
                    to="#"
                    variant="small-filled"
                    dataToggle="modal"
                    dataTarget="#import-questions"
                    icon={<CiImport size={18} color="#fff" />}
                /></div>

                <div className="table-search-button-item"><CreateButton
                    createButtonTitle="Export Questions"
                    to="#"
                    variant="small-filled"
                    dataToggle="modal"
                    dataTarget="#export-questions"
                    icon={<PiExportLight size={18} color="#fff" />}
                /></div>
            </div>
        </div>

    )
}
